/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { createContext, useState, ReactNode, useEffect, useContext } from "react";
import { API_CONSTANT_ONBOARDING } from "utils";

interface Country {
  COUNTRY_NAME: string;
  COUNTRY_CODE: string;
}

interface DropDownOptions {
  value: string;
  label: string;
}
interface Avatar {
  value: string;
  label: string;
  type: "default";
  image: string;
  video: string;
}
interface IvrLanguages {
  // LANGUAGE_ID: string;
  // NAME: string;
  // STATUS: string;
  value: string;
  label: string;
}

interface InstitutionData {
  countries: Country[];
  Instruction_Medium: DropDownOptions[];
  InstitutionType: DropDownOptions[];
  GradeLevels: DropDownOptions[];
  BoardType: DropDownOptions[];
  AddonPrograms: DropDownOptions[];
  InstituteImageTitles: DropDownOptions[];
  MaterialType: DropDownOptions[];
  SubjectOptions: DropDownOptions[];
  LeadershipSubjectOptions: DropDownOptions[];
  TeamProfileTypes: DropDownOptions[];
  Avatars: Avatar[];
  IvrLanguages: IvrLanguages[];
}

// Define the type for the context
interface AppContextType {
  globalData: InstitutionData;
  formChanged: boolean;
  setFormChanged: any;
  instData: any;
  setInstData: any;
  // setGlobalData: React.Dispatch<React.SetStateAction<object>>;
}

const defaultData = {
  countries: [],
  Instruction_Medium: [],
  InstitutionType: [],
  GradeLevels: [],
  BoardType: [],
  AddonPrograms: [],
  InstituteImageTitles: [],
  MaterialType: [],
  SubjectOptions: [],
  LeadershipSubjectOptions: [],
  TeamProfileTypes: [],
  Avatars: [],
  IvrLanguages: [],
};

const readInstituteSession = () => {
  try {
    const parsed = JSON.parse(sessionStorage.getItem("_DATA_") || "{}");
    return typeof parsed === "string" ? JSON.parse(parsed) : parsed;
  } catch {
    return {};
  }
};

// Create the context with default values
export const AppContext = createContext<AppContextType | undefined>(undefined);

// Provider component
export const AppProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [globalData, setGlobalData] = useState<InstitutionData>(defaultData);

  const [formChanged, setFormChanged] = useState<boolean>(() => {
    return JSON.parse(sessionStorage.getItem('formChanged') || 'false');
  });

  const [instData, setInstData] = useState<any>(() => {
    return readInstituteSession();
  });

  const fetchMetaData = async () => {
    try {
      const response = await axios.get(
        `${API_CONSTANT_ONBOARDING}/master/onboarding/metadata`
      );
      if (response?.data?.data) {
        const transformedData = Object.fromEntries(
          Object.entries(response?.data?.data).map(([key, value]) => {
            if (["countries"/* , "ivrlanguages" */].includes(key?.toLowerCase())) return [key, value]; // Keep countries as is
            return [
              key,
              (value as any)?.map((item) => ({ value: item, label: item })),
            ];
          })
        );
        setGlobalData((globalData) => transformedData as any);
      }
    } catch (err) {
      setGlobalData((globalData) => defaultData);
    }
  };

  useEffect(() => {
    fetchMetaData();
  }, []);

  useEffect(() => {
    sessionStorage.setItem('formChanged', JSON.stringify(formChanged));
  }, [formChanged]);

  useEffect(() => {
    if(!!instData?.BRANCH_ID) {
      sessionStorage.setItem('_DATA_', JSON.stringify(instData));
    }
  }, [instData?.BRANCH_ID]);

  return (
    <AppContext.Provider value={{ formChanged, setFormChanged, globalData, setInstData, instData }}>
      {children}
    </AppContext.Provider>
  );
};

export const useGlobalState = () => useContext(AppContext);
